import React from 'react';
import { Link } from 'react-router';
import Moment from 'moment';
import MomentRu from 'moment/locale/ru';
import $ from 'jquery';

class Item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dragOffset: null,
            startDrag: false,
            canTouch: false,
            prevTouch: null,
            transition: -1,
            addBookmark: false,
            addBookmarkIcon: false,
            prevDrag: 0
        };
        this.prevOffset = 0;

    }

    __formatDate(date) {
        let current_date = (new Date()).getTime();
        let input_date = new Date(date);
        let delta = current_date - input_date.getTime();
        return (delta > 24 * 60 * 60 * 1000) ? Moment(input_date).format('DD.MM.YYYY H:mm') : Moment(input_date).format('H:mm');
    }

    __touchMoveHandler(event) {
        if(this.state.canTouch) {
            let clientX = event.changedTouches[0].clientX;
            let delta = -1 * (this.state.prevTouch - clientX);
            if(!this.state.addBookmark) {
                if (delta >= -140) {
                    if (delta >= 0) {
                        this.setState({dragOffset: 0});
                    } else {
                        let addBookmark = (delta <= -120) ? true : false;
                        console.log('delta [%s]', delta);
                        this.setState({dragOffset: delta, addBookmarkIcon: addBookmark});
                    }
                }
            } else {
                delta = this.state.prevDrag + delta;
                if(delta <= 0) {
                    this.setState({dragOffset: delta,addBookmarkIcon:false});
                }
            }
        } else {
           this.setState({dragOffset:0});
        }
    }

    __touchStart(event) {

        this.setState({canTouch: window.canTouchElement, prevTouch: event.changedTouches[0].clientX});
    }

    __touchMoveEnd(event) {
        if(this.state.dragOffset <= -120) {
            this.props.addBookmark(this.props.id);
            this.setState({addBookmark: true, prevDrag: this.state.dragOffset,addBookmarkIcon: true});
        } else {
            if(this.state.dragOffset > -120) {
                if(this.props.bookmark && this.props.bookmark == true) {
                    this.props.addBookmark(this.props.id);
                }
                this.setState({dragOffset: 0, prevTouch: 0, addBookmark: false,addBookmarkIcon: false});
            }
        }

    }

    __onSelect(event) {
        event.preventDefault();
    }

    clickHandler(event) {
        event.preventDefault();
        this.props.more(this.props);

    }

    __linkClickHandler(event) {
        event.preventDefault();
    }

    addBookmark(event) {
        event.preventDefault();
        this.props.addBookmark(this.props.id);
    }

    render() {
        let className = ['m2feed_item'];
        let svg_icon = '<use xlink:href="#icon-star" width="26px" height="25px"></use>';
        let svg_icon_mobile = '<use xlink:href="#icon-bookmark-mobile" ></use>';

        if(this.props.bookmark && this.props.bookmark == true) {
            svg_icon = '<use xlink:href="#icon-bookmark-active" width="26px" height="25px"></use>';
        }

        if(this.state.addBookmarkIcon) {
            svg_icon_mobile = '<use xlink:href="#icon-add_bookmark-mobile"></use>';
        }



        if(this.props.new) {
            className.push('m2feed_item_new');
        }

        if(this.props.readed) {
            className.push('m2feed_item_readed');
        }

        if(this.props.active) {
            className.push('m2feed_item_active');
        }

        if(this.props.loading) {
            className.push('m2feed_item_loading');
        }

        let transformStyles = {
            transform: 'translateX(0px)',
            WebkitTransform: 'translateX(0px)'
        };
        let optionStyles = {
            width: '0px',
            paddingLeft: '0px',
            paddingRight: '0px',
        };


        if(this.state.canTouch) {
            transformStyles = {
                transform: 'translateX(' + (this.state.dragOffset) + 'px)',
                WebkitTransform: 'translateX(' + (this.state.dragOffset) + 'px)',
            };

            let padding = Math.abs(this.state.dragOffset) * 0.1;
            optionStyles = {
                width: Math.abs(this.state.dragOffset) + 'px',
                paddingLeft: padding + 'px',
                paddingRight: padding + 'px'
            };
        }

        return (
            <div onClick={this.clickHandler.bind(this)} onSelect={this.__onSelect.bind(this)} unselectable="no" className={className.join(' ')} onTouchStart={this.__touchStart.bind(this)} onTouchEnd={this.__touchMoveEnd.bind(this)} onTouchMove={this.__touchMoveHandler.bind(this)}>
                <div style={transformStyles} className="m2feed_item_drag" >
                    <div className="m2feed_item_source">
                        <Link to="#" onClick={this.__linkClickHandler.bind(this)} ><span>{this.props.source_name}</span></Link>
                        <div className="m2feed_date"><span>{this.__formatDate(this.props.feed_date)}</span></div>
                    </div>
                    <div className="m2feed_item_wrapper"unselectable="no" >
                        <div className="m2feed_item_info"unselectable="no" >
                            <div className="m2feed_item_title"><Link onClick={this.__linkClickHandler.bind(this)} unselectable="no" to="#" dangerouslySetInnerHTML={{__html: this.props.title}}></Link></div>
                            <div className="m2feed_item_anons"><Link onClick={this.__linkClickHandler.bind(this)}  unselectable="no" to="#" dangerouslySetInnerHTML={{__html: this.props.anons}}></Link></div>
                        </div>
                        <div className="m2feed_options">
                            <div className={"m2feed_bookmark" + (this.state.addBookmark ? " m2feed_bookmark_active" : "")}>
                                <Link onClick={this.addBookmark.bind(this)} href="#"><svg width="26px" height="25px" dangerouslySetInnerHTML={{__html: svg_icon}}></svg></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={optionStyles} className={"m2feed_options_mobile" + (this.state.addBookmarkIcon ? " m2feed_bookmark_active" : "")}>
                   <svg dangerouslySetInnerHTML={{__html: svg_icon_mobile}}></svg>
                </div>
            </div>
        );
    }
}
export default Item;


// WEBPACK FOOTER //
// ./src/components/Feeds/Item.js